var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4599 0.562551C18.2353 -0.187517 19.4658 -0.187517 20.2411 0.562551L23.2157 3.4402C23.6591 3.86913 24.2756 4.06944 24.8864 3.98304L28.9844 3.40341C30.0525 3.25233 31.048 3.9756 31.2344 5.03815L31.9495 9.11466C32.0561 9.72227 32.4371 10.2467 32.982 10.5358L36.6381 12.4756C37.591 12.9812 37.9712 14.1515 37.4975 15.1207L35.6799 18.839C35.409 19.3932 35.409 20.0414 35.6799 20.5956L37.4975 24.3139C37.9712 25.2831 37.591 26.4534 36.6381 26.959L32.982 28.8988C32.4371 29.1879 32.0561 29.7123 31.9495 30.3199L31.2344 34.3964C31.048 35.459 30.0525 36.1823 28.9844 36.0312L24.8864 35.4515C24.2756 35.3651 23.6591 35.5655 23.2157 35.9944L20.2411 38.872C19.4658 39.6221 18.2353 39.6221 17.4599 38.872L14.4853 35.9944C14.0419 35.5655 13.4254 35.3651 12.8146 35.4515L8.71667 36.0312C7.64852 36.1823 6.65303 35.459 6.46664 34.3964L5.75157 30.3199C5.64498 29.7123 5.26396 29.1879 4.71902 28.8988L1.06301 26.959C0.110054 26.4534 -0.27019 25.2831 0.203573 24.3139L2.02117 20.5956C2.29209 20.0414 2.29209 19.3932 2.02118 18.839L0.203573 15.1207C-0.27019 14.1515 0.110053 12.9812 1.063 12.4756L4.71902 10.5358C5.26396 10.2467 5.64498 9.72227 5.75157 9.11466L6.46664 5.03815C6.65303 3.9756 7.64852 3.25233 8.71667 3.40341L12.8146 3.98304C13.4254 4.06944 14.0419 3.86913 14.4853 3.4402L17.4599 0.562551Z",
    fill: "#0E9926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15L16.375 25L12 20.4545",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/ConfirmationIcon.8dd66b4b4ebc8c7a67a76f00dfc986ae.svg";
export { ForwardRef as ReactComponent };